import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useConcreteMixDesignsContext } from '../MixDesignsContext'
import { ConcreteMixDesign } from '../MixDesignsContext/types'

export function useCreate(): CreateHeaderActionOptions<ConcreteMixDesign> {
  const {
    create: { toggle },
  } = useConcreteMixDesignsContext()

  return {
    entity: 'Concrete Mix Design',
    permission: Permission.CreateConcreteMixDesign,
    modal: { type: 'custom', toggle },
  }
}
